import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
	GetCampaign,
	GetCampaignEventLogs,
	AddEventLog,
	UpdateEventLog,
	GetEventLogDetails,
	DeleteEventLog
} from '../../../Services';
import Spinner from '../../../components/spinner/Spinner';
import './CampaignNotesScreen.css';
import { toast } from 'react-toastify';
import PageHeadline from '../../../components/pageHeadline/PageHeadline';
import CampaignTabs from '../../../components/campaignTabs/CampaignTabs';
import ModalDialog from '../../../components/modalDialog/ModalDialog';
import ModalDialogContent from '../../../components/modalDialog/modalDialogContent/ModalDialogContent';
import ModalDialogButtons from '../../../components/modalDialog/modalDialogButtons/ModalDialogButtons';
import CampaignButtonsContainer from '../campaignButtonsContainer/CampaignButtonsContainer';
import { createGuid } from '../../../utils/Common';
import Moment from 'react-moment';
import { useStateValue } from '../../../StateProvider';

const CampaignNotesScreen = () => {
	const [ { user }, dispatch ] = useStateValue();
	const [ isLoading, setIsLoading ] = useState(false);
	const [ isLoadingDialog, setIsLoadingDialog ] = useState(false);
	const [ isSubmitting, setIsSubmitting ] = useState(false);
	const [ campaign, setCampaign ] = useState();
	const [ eventLogs, setEventLogs ] = useState([]);
	const [ formData, setFormData ] = useState({});
	const [ showDialog, setShowDialog ] = useState(false);
	const [ newId, setNewId ] = useState();
	const [ editId, setEditId ] = useState();
	const { campaignId } = useParams();
	const navigate = useNavigate();

	useEffect(
		() => {
			if (campaignId) {
				getCampaign();
				getCampaignEventLogs();
			}
		},
		[ campaignId ]
	);

	const getCampaign = async () => {
		const response = await GetCampaign(campaignId);

		if (response) {
			document.title = 'Notes - ' + response.name;

			setCampaign(response);
		}
	};

	const getCampaignEventLogs = async () => {
		setIsLoading(true);

		const response = await GetCampaignEventLogs(campaignId);

		if (response.success) {
			let tempEventLogs = response.data;

			setEventLogs(tempEventLogs);
		}

		setIsLoading(false);
	};

	const getEventLogDetails = async (id) => {
		setIsLoadingDialog(true);

		const response = await GetEventLogDetails(id);

		if (response.success) {
			let tempEventLogDetails = response.data;

			setFormData(tempEventLogDetails);
		}

		setIsLoadingDialog(false);
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSaveEventLog = async (e) => {
		e.preventDefault();

		let isValid = document.querySelector('form').reportValidity();

		if (!isValid) {
			return;
		}

		setIsSubmitting(true);

		let data = {
			userId     : user.id,
			campaignId : campaignId,
			type       : 'Note',
			status     : 'Active',
			message    : formData.message
		};

		let response;

		if (editId) {
			data.id = editId;
			response = await UpdateEventLog(editId, data);
		} else {
			data.id = newId;
			response = await AddEventLog(data);
		}

		if (response.success) {
			toast.success('Note successfully ' + (editId ? 'updated' : 'added'));
			getCampaignEventLogs();
		}

		setIsSubmitting(false);
		setShowDialog(false);
	};

	const handleDeleteEventLog = async (e, id) => {
		e.preventDefault();

		if (window.confirm('Are you sure that you want to delete selected note?')) {
			let response = await DeleteEventLog(id);

			if (response) {
				toast.success('Note successfully deleted');
				getCampaignEventLogs();
			}
		}
	};

	const handleNext = async () => {
		navigate(`/setup/${campaignId}/finish`);
	};

	const handleToggleDialog = async (id) => {
		setShowDialog(!showDialog);

		if (!showDialog) {
			if (id) {
				//edit
				setEditId(id);
				await getEventLogDetails(id);
			} else {
				//new
				setNewId(createGuid());
			}
		} else {
			setFormData({});
			setNewId();
			setEditId();
		}
	};

	return (
		<Fragment>
			<div className="container-fluid campaign-main-container">
				<PageHeadline
					campaign={campaign}
					headline={`Campaign - ${campaign ? campaign.name : ''}`}
					linkText="Back To List"
					linkUrl="/campaigns/list"
				/>

				<CampaignTabs />

				<Fragment>
					<div className="campaign-form-container">
						<div className="row">
							<div className="col-12">
								<button
									className="btn btn-primary mb-3"
									type="button"
									onClick={() => handleToggleDialog()}
								>
									Add Note
								</button>
							</div>
						</div>

						{isLoading && <Spinner />}

						<div className="row mb-1">
							<div className="col-12">
								{!isLoading && eventLogs && eventLogs.length > 0 ? (
									<table className="table border landing-pages-table">
										<thead>
											<tr>
												<th scope="col" className="date-time text-start">
													<span>Date</span>
												</th>
												<th scope="col" className="message">
													<span>Text</span>
												</th>
												<th scope="col" className="message">
													<span>Submitted By</span>
												</th>
												<th />
											</tr>
										</thead>
										<tbody>
											{eventLogs.map((eventLog, index) => (
												<tr key={eventLog.id}>
													<td className="date-time text-start">
														{eventLog.dateCreated ? (
															<Moment format="MM/DD/YYYY hh:mm A">
																{eventLog.dateCreated}
															</Moment>
														) : (
															''
														)}
													</td>
													<td className="message">{eventLog.message}</td>
													<td className="message">
														{eventLog.user ? eventLog.user.displayName : ''}
													</td>
													<td className="keyword-action text-end">
														{user.id === eventLog.userId && (
															<Fragment>
																<button
																	href="#"
																	className="btn btn-link p-0"
																	onClick={() => handleToggleDialog(eventLog.id)}
																	title="Edit Note"
																>
																	<i className="fa-solid fa-pen" />
																</button>
																<button
																	href="#"
																	className="btn btn-link p-0 ms-2"
																	onClick={(e) =>
																		handleDeleteEventLog(e, eventLog.id)}
																	title="Delete Note"
																>
																	<i className="fa-solid fa-trash-can" />
																</button>
															</Fragment>
														)}
													</td>
												</tr>
											))}
										</tbody>
									</table>
								) : (
									<div className="p-2 border w-100">
										<i>No notes</i>
									</div>
								)}
							</div>
						</div>

						{showDialog && (
							<ModalDialog position="right-sidebar">
								<ModalDialogContent align="start">
									{editId && isLoadingDialog ? (
										<Spinner />
									) : (
										<form className="row">
											<div className="col-12 mb-3">
												<label htmlFor="message" className="form-label">
													Text:
												</label>
												<textarea
													className="form-control"
													name="message"
													value={formData.message || ''}
													onChange={handleChange}
													disabled={isSubmitting}
													rows={5}
												/>
											</div>
										</form>
									)}
								</ModalDialogContent>
								<ModalDialogButtons>
									<Fragment>
										<button className="btn btn-primary" type="button" onClick={handleSaveEventLog}>
											{isSubmitting ? (
												<Fragment>
													<span className="spinner-border m-0 me-2" />
													<span>Saving</span>
												</Fragment>
											) : (
												<span>Save</span>
											)}
										</button>
										<button
											className="btn btn-outline-primary ms-2"
											type="button"
											onClick={handleToggleDialog}
											disabled={isSubmitting}
										>
											Cancel
										</button>
									</Fragment>
								</ModalDialogButtons>
							</ModalDialog>
						)}
					</div>

					<CampaignButtonsContainer
						campaign={campaign}
						showSaveButton={false}
						onSaveNext={() => handleNext()}
						saveNextButtonText="Next"
						disabled={isSubmitting}
					/>
				</Fragment>
			</div>
		</Fragment>
	);
};

export default CampaignNotesScreen;
